import React from 'react';
import PropTypes from 'prop-types';
import InvoiceBasicInfoSection from './invoiceEditorSections/InvoiceBasicInfoSection';
import InvoiceOtherFieldsSection from './invoiceEditorSections/InvoiceOtherFieldsSection';

const InvoiceEditor = props => {

  const handleInputChange = (ev, value, errorMessage) => props.onFieldChange(ev, value, errorMessage);

  return (
    <React.Fragment>
      <InvoiceBasicInfoSection
        basicInfoData={ props.invoice }
        onFieldChange={ handleInputChange }
      />
      <hr />
      <InvoiceOtherFieldsSection
        invoiceData={ props.invoice }
        onFieldChange={ handleInputChange }
      />
    </React.Fragment>
  );
};

InvoiceEditor.propTypes = {
  onFieldChange: PropTypes.func,
  invoice: PropTypes.object
};

export default InvoiceEditor;


// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceLinesSlidingPanel/invoiceEditor/InvoiceEditor.js